import { render, staticRenderFns } from "./order-summary-message.vue?vue&type=template&id=fa1e914a"
import script from "./order-summary-message.vue?vue&type=script&lang=js"
export * from "./order-summary-message.vue?vue&type=script&lang=js"
import style0 from "./order-summary-message.vue?vue&type=style&index=0&id=fa1e914a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports